module.exports = __webpack_public_path__ + "static/media/md-checkmark-circle-outline.32666418.svg";